export default "__VITE_ASSET__Dnb4$kL2__"